import { Dispatch, SetStateAction } from 'react'
import { Memoized } from './dependencies'
import { useEffect, useLocalStorage, useState } from '.'

const usePersistedState = <S>(
  key: string,
  defaultValue: S,
): [S, Memoized<Dispatch<SetStateAction<S | undefined>>>] => {
  const [value, setValue] = useState<S>()

  const storage = useLocalStorage()

  useEffect(() => {
    if (!storage) return
    const possibleValue = storage.getItem(key) ?? null
    if (possibleValue !== null) {
      setValue(JSON.parse(possibleValue))
    }
  }, [key, storage])

  useEffect(() => {
    if (!storage) return
    if (value !== undefined) {
      storage.setItem(key, JSON.stringify(value))
    } else {
      storage.removeItem(key)
    }
  }, [key, value, storage])

  return [value ?? defaultValue, setValue]
}

export default usePersistedState
